module.exports = __webpack_public_path__ + "static/04-0eca411361673820bc007c6ad363cbb1.jpg";